module.exports = __webpack_public_path__ + "static/Yuii@2x.36122a48.png";